<script>
export default {
  data() {
    return {
      OrderNumber: this.$route.params?.orderNumber
    };
  }
};
</script>
<template>
  <div>
    <BaseOrderModal :orderUUID="OrderNumber" :value="true" :inline="true">
    </BaseOrderModal>
  </div>
</template>
